import React from "react";
import { Route, Routes } from "react-router-dom";
import {
  CustomerSegmentationList,
  ManageSegmentation,
  SegmentDetails,
} from "./containers";
import { ProtectedRoute } from "../../shared";

export const CustomerSegmentation = () => {
  return (
    <Routes>
      <Route index element={<CustomerSegmentationList />} />
      <Route element={<ProtectedRoute allowedRoute={["segment-create"]} />}>
        <Route path="create" element={<ManageSegmentation />} />
      </Route>

      <Route path="details/:id">
        <Route element={<ProtectedRoute allowedRoute={["segment-view"]} />}>
          <Route index element={<SegmentDetails />} />
        </Route>
        <Route element={<ProtectedRoute allowedRoute={["segment-modify"]} />}>
          <Route path="edit" element={<ManageSegmentation />} />
        </Route>
      </Route>
    </Routes>
  );
};
